/* Mobile Menu Open */
var mobilemenu = document.getElementsByClassName("menu-open");
mobilemenu[0].onclick = function (event) {
    event.preventDefault()
    document.body.classList.toggle("showmenu")
}

/* Mobile menu concertina open */
var acc = document.getElementsByClassName("hassub");
for (var i = 0; i < acc.length; i++) {
    // acc[i].querySelector('a').removeAttribute('href');
    acc[i].querySelector('.nav-wrap').addEventListener("click", function() {
        // Already opened
        if(this.parentElement.classList.contains('showsub')) {
            this.parentElement.classList.remove('showsub');
        } else {
            // Close all open menu dropdowns
            [].forEach.call(acc, function(item) {
                item.classList.remove('showsub');
            });
            // Open selected dropdown
            this.parentElement.classList.add('showsub');
        }
    });
}

let messageInput = document.getElementById('Form_ContactForm_Message');
if(messageInput) {
    messageInput[0].onclick(function() {
        this.style.height = 'auto';

        this.style.height = (this.scrollHeight) + 'px';
    })
}
